var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.getClasses,staticStyle:{"white-space":"normal","display":"inline-block","height":"auto","width":"auto","padding":"0.25em 0.75em"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }